const MOBILE_REGEX =
  /iOS|iPhone|iPad|iPod|Android|BlackBerry|IEMobile|Windows Phone|Opera Mini|mobile/i;

function getUserAgent(req?: Request): string {
  if ("navigator" in globalThis) {
    const result =
      globalThis.navigator.platform === "MacIntel" && globalThis.navigator.maxTouchPoints > 1
        ? "iOS"
        : "";
    return result || globalThis.navigator.userAgent || "";
  }
  return req?.headers?.get("user-agent") || "";
}

/**
 * Check if the user is on a mobile device using userAgent,
 * this is a simple way to detect if the user is on a mobile device
 * it is not a perfect detection, but it is a good enough detection for most cases
 * if you need a more precise detection, you can use the window.innerWidth and window.innerHeight
 * to detect if the user is on a mobile device
 *
 * @example
 * ```ts
 * if (isMobileDevice()) {
 *   console.log('the user is on a mobile device');
 * }
 * ```
 *
 * if using in a server component, you can pass in a request object to get the user agent
 * ```ts
 * export async function getServerSideProps(context: GetServerSidePropsContext) {
 *   const req = context.req;
 *   return {
 *     props: {
 *       isMobile: isMobileDevice(req),
 *     },
 *   };
 * }
 * ```
 * @returns true if the user is on a mobile device
 */
export function isMobileDevice(req?: Request): boolean {
  const userAgent = getUserAgent(req);
  return MOBILE_REGEX.test(userAgent);
}

/**
 * Alias for orientation-prompt gating on phones and tablets (including iPad landscape).
 */
export function isMobileGameDevice(req?: Request): boolean {
  return isMobileDevice(req);
}

/**
 * Check if the user is on a touch device
 * This can only run in the browser, not in the server
 * @returns true if the user is on a touch device
 */
export function doesSupportTouch(): boolean {
  if ("window" in globalThis) {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  }
  return false;
}
